import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1cca758c")

_pushScopeId("data-v-1cca758c")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" カルテ一覧 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_back_button = _resolveComponent("back-button")
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_patient_info = _resolveComponent("patient-info")
  const _component_consultation_list = _resolveComponent("consultation-list")
  const _component_bookmark_list = _resolveComponent("bookmark-list")
  const _component_tabs = _resolveComponent("tabs")
  const _component_vue_content_remain = _resolveComponent("vue-content-remain")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _createVNode("h2", null, [
            _createVNode(_component_back_button),
            _hoisted_1
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_patient_info, { class: "vue-content-margin-bottom" }),
      _createVNode(_component_vue_content_remain, null, {
        default: _withId(() => [
          (_ctx.patientWrite)
            ? (_openBlock(), _createBlock(_component_tabs, {
                key: 0,
                tabs: _ctx.tabs,
                onTab: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectTab($event)))
              }, {
                default: _withId(() => [
                  (_ctx.selectedIndex===0)
                    ? (_openBlock(), _createBlock(_component_consultation_list, {
                        key: 0,
                        class: "vue-content-remain-tab-child"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.selectedIndex===1)
                    ? (_openBlock(), _createBlock(_component_bookmark_list, {
                        key: 1,
                        class: "vue-content-remain-tab-child"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["tabs"]))
            : (_openBlock(), _createBlock(_component_consultation_list, {
                key: 1,
                class: "vue-content-remain-child"
              })),
          _createVNode(_component_consultation_list)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})